import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
import { useThemeValue } from '../system';
import Dropdown from '../Dropdown';

function PageDropdown(props) {
  var themeProps = useThemeValue('pageDropdown');
  return /*#__PURE__*/React.createElement(Dropdown, _extends({
    theme: "white",
    variant: "outline"
  }, themeProps, props));
}

export default PageDropdown;